import { Box, Divider, Stack, Typography } from '@mui/material';

const FaqServiceSectionWrapper = ({ title, children }) => {
  return (
    <Box width={'100%'}>
      <Typography variant="h5" justifyContent={'center'} display={'flex'}>
        {title}
      </Typography>
      <Divider />
      <Stack gap={1}>{children}</Stack>
    </Box>
  );
};
export default FaqServiceSectionWrapper;
